/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { useProductDetails } from '@/data/Content/ProductDetails';
import { useSkuListTable } from '@/data/Content/SkuListTable';
import { ContentContext } from '@/data/context/content';
import { Box, Tooltip, Typography } from '@mui/material';
import { FC, useContext } from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const ProductDetailsPromos: FC = () => {
	const { promos } = useContext(ContentContext) as ReturnType<typeof useProductDetails> &
		ReturnType<typeof useSkuListTable>;
	return (
		<>
			{promos?.map((promoDesc, i) => (
				 <Typography key={i} variant="body1" sx={{color:'darkslategray'}} gutterBottom>
						{promoDesc?.split("~")?.at(0)??''}
							<Tooltip 
								title={<Box dangerouslySetInnerHTML={{__html:promoDesc?.split('~')?.at(1)??''}}></Box>}
								leaveTouchDelay={2000} enterTouchDelay={20}
								arrow
							>
							<InfoOutlinedIcon sx={{color:'darkslategray', fontSize:'1.3rem'}}/>
							</Tooltip>
					</Typography>	
			))}				 
		</>
	 );
};